/**
 * The attributes are read from the React Native RudderStack SDK, which web does not load, so web
 * relays no marketing identity.
 */
export const cacheMarketingIdentity = async (): Promise<void> => {};
